<template>
    <f7-page
        :class="`explore goals-scroll withHalfBg`"
        name="Goals"
        no-swipeback
        no-navbar
    >
        <!-- <div style="position: relative">
            <f7-link
                style="position: absolute; top: 10px; padding: 0 16px; right: 0px; font-size: 30px; color: #999999"
                href="/settings/goals"
                icon="ion-edit"
            />
        </div> -->
        <div class="explore-top">
            <f7-block>
                <h1 style="margin: 0px 0 2px 0; text-align: left">{{ user.username ? `Hey ${user.username}!` : 'Hi there!' }}</h1>
                <div style="text-align: left">What goal do you want to work on...</div>
            </f7-block>
            <div class="exploreContentSectionWave" />

            <f7-block
                style="margin-top: -40px"
                class="tabsContentSection"
            >
                <f7-block-title
                    v-if="myTopics.length"
                    style="margin: 0px 0px 10px 0px; line-height: 20px; text-align: left;"
                >Your goals
                    <f7-link
                        v-if="myTopics.length"
                        href="/onboarding/goals?fromHome=1"
                        style="float: right; float: right; font-size: 15px; font-family: AndesMedium; "
                    >Manage your goals</f7-link>

                </f7-block-title>
                <template v-for="topic in topics">
                    <topic-card
                        v-show="isEligible(topic) && myTopics.indexOf(topic.id) > -1"
                        :key="topic.id"
                        :topic="topic"
                    />
                </template>
                <f7-block-title style="margin: 20px 0px 10px 0px; line-height: 20px; text-align: left;">{{ myTopics.length? 'More goals' : 'Pick your first goal' }}</f7-block-title>
                <template v-for="topic in topics">
                    <topic-card
                        v-show="isEligible(topic) && myTopics.indexOf(topic.id) === -1"
                        :key="`key1-${topic.id}`"
                        :topic="topic"
                    />
                </template>
            </f7-block>
        </div>
        <app-tabbar tab="goals" />
    </f7-page>
</template>

<script>
import AppTabbar from '../components/appTabbar.vue';
import TopicCard from '../components/topicCard.vue';

import utils from '../js/utils';

export default {
    store: ['api', 'user', 'topics', 'topicsIndex', 'myTraits', 'myTopics'],
    components: {
        AppTabbar,
        TopicCard
    },
    data () {
        return {};
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },

    created: function () { },
    mounted: function () { },
    beforeDestroy: function () { },
    methods: {
        isEligible: function (topic) {
            return topic.type === 'goal' && utils.checkTraits(this.myTraits, topic);
        },
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';

.icon {
    border-radius: 50%;
    height: 50px;
    width: 50px;
    line-height: 50px;
    display: inline-block;
    color: @green;
    // border: 1px solid @darkGreen;
}
.explore-top {
    padding-top: 16px;
    margin-top: 20px;
}
.exploreContentSectionWave {
    padding-top: 20px;
    width: 100%;
    min-height: 100px;
    max-width: 100vw;
    overflow-x: hidden;
    background-color: @darkBackground;
    background-image: url('../img/0.4/bgwave.png');
    // background-size: 307px 11px;
    background-size: 460.5px 16.5px;
    background-position: top left;
    background-repeat: repeat-x;
}
.tabsContentSection {
    min-height: 80vh;
    width: 100%;
    background-color: @darkBackground;
    margin-top: -100px;
    position: relative;
    z-index: 1;
}
.theme-dark {
    .exploreContentSectionWave {
        background-color: #1c1c1d;
        background-image: url('../img/0.4/bgwavedark.png');
    }
    .tabsContentSection {
        background-color: #1c1c1d;
    }
}
#explore-shape {
    width: 243px;
    height: 166.5px;
    position: absolute;
    top: 10px;
    right: 0px;
}
</style>
